<template>
  <div>
    <q-select
      dense
      outlined
      :bg-color="disabled ? 'brand-7' : ''"
      :disable="disabled"
      v-model="unidade"
      :options="listaUnidadesOptions"
      map-options
      option-value="id"
      option-label="nome"
      class="input-mobile"
      behavior="menu"
      use-input
      :clearable="temPermissaoTodasUnidades"
      :display-value="
        unidade?.nome?.length > 9
          ? `${unidade?.nome.substring(0, 9)}..`
          : unidade?.nome
      "
      @filter="filterFn"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="white">Nenhum resultado</q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="unidade?.nome">
        {{ unidade?.nome }}
      </q-tooltip>
    </q-select>
    <div
      v-if="semUnidadeSelecionada"
      class="text-negative q-mt-xs text-caption"
    >
      Selecione uma Unidade para continuar
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import { usuarioTemPermissaoVisualizarTodasUnidades } from "@/helpers/permissaoHelper";

export default {
  props: ["modelValue", "disabled", "todos"],
  emits: ["update:modelValue", "semPermissaoUnidade"],

  setup(props, { emit }) {
    const listaUnidadesOptions = ref([]);
    const store = useStore();
    const unidade = ref();
    const listaContratosOptions = ref([]);
    const contrato = ref();

    const temPermissaoTodasUnidades = computed(() =>
      usuarioTemPermissaoVisualizarTodasUnidades(store)
    );

    const listarUnidades = async (val) => {
      const resposta = await store.dispatch("org/listarUnidades", {});
      listaUnidadesOptions.value = resposta.listaUnidades;

      if (props.todos == true && temPermissaoTodasUnidades.value) {
        listaUnidadesOptions.value.unshift({ id: "", nome: "Todos" });
      }

      store.dispatch("org/saveTodasUnidade", resposta.listaUnidades);

      const needle = val.toLowerCase();
      listaUnidadesOptions.value = listaUnidadesOptions.value.filter(
        (v) => v.nome.toLowerCase().indexOf(needle) > -1
      );
    };

    const getUnidade = async () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        const resposta = await store.dispatch("org/listarUnidades", {});
        const unidadesVinculadas = resposta.listaUnidades;
        let getunidade = localStorage.getItem("unidade");

        unidadesVinculadas.forEach((value) => {
          if (value.id == JSON.parse(getunidade).id) {
            unidade.value = JSON.parse(getunidade);
          } else {
            return;
          }
        });

        listarContratos();
      }
    };

    onMounted(getUnidade);

    const listarContratos = async () => {
      listaContratosOptions.value = [];

      try {
        const response = await store.dispatch("org/listarContratosUnidade", {
          unidade: unidade.value.id,
        });

        contrato.value = response.data.model.contract_id;
        store.commit("org/SAVE_CONTRACT", contrato.value);
        localStorage.setItem("lastContract", contrato.value);
      } catch (error) {
        console.log(error);
      }
    };

    const semUnidadeSelecionada = computed(() => {
      if (temPermissaoTodasUnidades.value) return false;
      const id = unidade.value?.id;
      return !id || id === "";
    });

    watch(
      () => unidade.value,
      (novoValor, valorAnterior) => {
        if (!temPermissaoTodasUnidades.value) {
          const id = novoValor?.id;
          if ((!id || id === "") && valorAnterior?.id) {
            unidade.value = valorAnterior;
            return;
          }
        }

        if (unidade.value == "" || unidade.value == undefined) {
          unidade.value = {
            nome: "",
            id: "",
            logo: "",
            codigoUnidadeIntegracao: "",
          };
          emit("semPermissaoUnidade", semUnidadeSelecionada.value);
          return;
        }
        localStorage.unidade = JSON.stringify(unidade.value);
        store.dispatch("org/saveUnidade", unidade.value);
        if (unidade.value.id && unidade.value.id !== "") {
          listarContratos();
        }
        emit("semPermissaoUnidade", semUnidadeSelecionada.value);
      }
    );

    return {
      listaUnidadesOptions,
      unidade,
      listarUnidades,
      listarContratos,
      temPermissaoTodasUnidades,
      semUnidadeSelecionada,

      filterFn(val, update) {
        listarUnidades(val);
        setTimeout(() => {
          update();
        }, 1000);
      },
    };
  },
};
</script>

<style scoped>
.mobileUnidade {
  margin-left: -20px;
}
@media (max-width: 600px) {
  .input-mobile {
    font-size: 16px !important;
  }
}
@media (max-width: 480px) {
  .input-mobile {
    font-size: 16px !important;
  }
}
</style>
